import { Misc, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { AppService, DomainTypes } from "../../../DomainTypes";
import BankAccountType from "../../../Models/Catalogue/Pipeline/BankAccountType";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class BankAccountTypeCatalogueEntry extends CatalogueEntry<BankAccountType> {

    private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);

    constructor() {
        super("Bank Account Types", BankAccountType);
    }

    public get editRole() {
        return CatalogueRoles.BankAccountTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.bankAccountTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.saveBankAccountTypes;
    }

    public renderRow(group: BankAccountType, meta: Model.TransformMetaType<BankAccountType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.bankAccountTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}